export default "./spinner.svg"